import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-115d65e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-address" }

import { useI18n } from "vue-i18n";
    
    
export default /*#__PURE__*/_defineComponent({
  __name: 'FormGeolocationCompletedByPartner',
  props: {
        'index': {
            type: Number
        },
        'number': {
            type: Number
        },
        'reference': {
            type: Object,
            default: () => ({
                manualMethod: null,
                address: null,
                zipCode: null,
                city: null,
                country: null,
                latitude: null,
                longitude: null
            })
        },
        'optionsCountry': {
            type: Object
        }
    },
  setup(__props) {

const props = __props;

    const { t } = useI18n();
    
    // Define Props
    

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("small", null, _toDisplayString(`${_unref(t)('ProductForm.Geolocation.addressCompletedByPartner')}`), 1)
    ]),
    _createVNode(_component_FormKit, {
      disabled: "",
      type: "text",
      step: "any",
      label: props.number + '. Adresse*',
      name: "address",
      placeholder: "Adresse"
    }, null, 8, ["label"]),
    _createVNode(_component_FormKit, {
      disabled: "",
      type: "text",
      step: "any",
      label: props.number + '. Code Postal*',
      name: "zipCode",
      placeholder: "Code Postal"
    }, null, 8, ["label"]),
    _createVNode(_component_FormKit, {
      disabled: "",
      type: "text",
      step: "any",
      label: props.number + '. Ville*',
      name: "city",
      placeholder: "Ville"
    }, null, 8, ["label"]),
    _createVNode(_component_FormKit, {
      disabled: "",
      type: "select",
      label: props.number + '. Pays*',
      name: "country",
      placeholder: "Pays",
      options: props.optionsCountry
    }, null, 8, ["label", "options"]),
    _createVNode(_component_FormKit, {
      disabled: "",
      type: "textarea",
      step: "any",
      rows: "2",
      label: props.number + '. Adresse correspondant aux coordonnées*',
      name: "formattedAddress",
      placeholder: "Adresse complète"
    }, null, 8, ["label"]),
    _createVNode(_component_FormKit, {
      disabled: "",
      type: "number",
      step: "any",
      label: props.number + '. Latitude*',
      name: "latitude",
      placeholder: "Latitude"
    }, null, 8, ["label"]),
    _createVNode(_component_FormKit, {
      disabled: "",
      type: "number",
      step: "any",
      label: props.number + '. Longitude*',
      name: "longitude",
      placeholder: "Longititude"
    }, null, 8, ["label"])
  ], 64))
}
}

})